import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import navigate from "../routes/navigate"
import { current_route } from "../routes/router"

export const Routerview = CreateRenderFunction({
  computed: {
    route() {
      return current_route.value
    },
  },
  data: {},
  methods: {
    close() {
      navigate()
    },
  },
  render() {
    const Component = this.route.component

    return (
      <div class="router-view">
        {Component && <Component {...this.route.props} />}
        <div
          class="router-backdrop bg-glass-dark overflow-hidden"
          onClick={this.close}
          onTouchMove={(e: Event) => {
            e.stopPropagation()
            e.preventDefault()
          }}
          onWheel={(e: Event) => {
            e.stopPropagation()
            e.preventDefault()
          }}
        ></div>
      </div>
    )
  },
})
